var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { class: [_vm.hasContainerPanel ? "container-panel" : ""] }, [
      _vm.showHeader
        ? _c("div", { staticClass: "header" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(" " + _vm._s(_vm.data.title) + " ")
            ])
          ])
        : _vm._e(),
      _c(
        "div",
        {
          class: {
            row: !_vm.hasContainerPanel && _vm.isVertical,
            "options-vertical": _vm.hasContainerPanel && _vm.isVertical,
            options: !_vm.isVertical
          }
        },
        _vm._l(_vm.data.options, function(item) {
          return _c(
            "div",
            {
              key: item.id,
              class: [
                !_vm.hasContainerPanel && _vm.isVertical ? _vm.optionCol : ""
              ]
            },
            [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c("check-box", {
                      class: _vm.isReadOnly
                        ? "row-check disabled-check"
                        : "row-check",
                      attrs: {
                        disabled: _vm.isReadOnly,
                        text: item.name,
                        value: item.checked
                      },
                      on: {
                        input: function($event) {
                          return _vm.onCheckChange(item, $event)
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm.isRecordOther(item)
                  ? _c(
                      "div",
                      { staticClass: "col-8" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: item.checked ? "required" : "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-input", {
                                      attrs: {
                                        "custom-error-msg":
                                          "El campo es requerido",
                                        disabled:
                                          _vm.isReadOnly || !item.checked,
                                        error: errors[0]
                                      },
                                      model: {
                                        value: item.other,
                                        callback: function($$v) {
                                          _vm.$set(item, "other", $$v)
                                        },
                                        expression: "item.other"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ]
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }